export default __webpack_public_path__ + "static/media/lending.c0708515.png";